var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"denomination-select"},[_vm._l((_vm.items),function(item){return [(!item.disabled)?_c('div',{key:item[_vm.keyFields.id],staticClass:"denomination-select-item",class:{
        disabled: _vm.disabled,
        active: _vm.activeId === item[_vm.keyFields.id],
      },on:{"click":function($event){return _vm.clickHandler(item)}}},[_c('div',{staticClass:"show-price"},[_vm._v(_vm._s(item[_vm.keyFields.value]))]),(_vm.showSalePrice)?_c('div',{staticClass:"sale-price"},[_vm._v(" 售价"+_vm._s(item[_vm.keyFields.salePrice])+"元 ")]):_vm._e()]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }